module.exports = __webpack_public_path__ + "img/joker_about.41b5c657.png";